import type { User } from '@takeshape/schema';
import api from 'app/common/utils/api';
import type { AxiosResponse } from 'axios';

export async function getSSOAuthorizeUrl(provider: string): Promise<AxiosResponse<{ authorizeUrl: string }>> {
  const params = {
    method: 'POST',
    path: 'sso-authorize',
    data: { provider }
  };

  return api(params);
}

export async function ssoLogin(code = '', provider = ''): Promise<{ data: User }> {
  const params = {
    method: 'POST',
    path: 'sso-login',
    data: { code, provider }
  };

  return api(params);
}
